// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BP-z","isFullWidth":"CP-z","landingPageVideo":"DP-z","play":"EP-z","iframeVideo":"FP-z","playHidden":"GP-z","fullwidth":"HP-z"};